import { BPaginationNav } from './pagination-nav';
import { pluginFactory } from '../../utils/plugins';
var PaginationNavPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BPaginationNav: BPaginationNav
  }
});
export { PaginationNavPlugin, BPaginationNav };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/pagination-nav/index.js
// module id = flwA
// module chunks = 0